import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import api from "./apiClient";

import cookiesHelper from "../helpers/cookies";

import { IModuleWithFeatureAndSubscription, ISaveSubscribedModuleFeature } from "../interfaces/services";

import useToast from "./useToast";

export const useGetSubscribedModuleFeatures = (schoolId: number | null) => {
    const queryFn = async (): Promise<IModuleWithFeatureAndSubscription[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`subscribed-module-features/school/admin/${schoolId}/no-domain`);
        return res.data?.length ? res.data : [];
    };

    return useQuery({
        queryKey: ['subscribed_module_features', schoolId],
        queryFn,
        retry: 0,
        enabled: !!schoolId,
    });
};

export const useSaveSubscribedModuleFeature = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: ISaveSubscribedModuleFeature) => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.put('/subscribed-module-features', data);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['subscribed_module_features'] });
        },
        onError: (error: any) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error?.response?.data?.message ?? "Something went wrong"
            });
        },
    });
};